// extracted by mini-css-extract-plugin
module.exports = {"root":"OptionsButton_root__17yqi","text":"OptionsButton_text__3Nv8M"};